var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9905 2C9.53585 2 7.54601 3.86548 7.54601 6.16667V9.5C7.54601 10.6464 8.03983 11.6846 8.83894 12.438C6.91604 13.0344 5.72186 14.1627 5.00677 15.3353C4.0033 16.9808 4.00001 18.6134 4 18.6669L4.00014 21.1667C4.00018 21.6269 4.39814 22 4.88903 22H19.1111C19.602 22 20 21.6269 20 21.1667V18.6667C20 18.6142 19.9971 16.982 18.9938 15.3362C18.2771 14.1604 17.0786 13.0289 15.1467 12.4335C15.943 11.6805 16.4349 10.6441 16.4349 9.5V6.16667C16.4349 3.86548 14.4451 2 11.9905 2ZM9.32378 6.16667C9.32378 4.78595 10.5177 3.66667 11.9905 3.66667C13.4632 3.66667 14.6571 4.78595 14.6571 6.16667V9.5C14.6571 10.8807 13.4632 12 11.9905 12C10.5177 12 9.32378 10.8807 9.32378 9.5V6.16667ZM5.77778 18.6682C5.77778 18.6682 5.79019 17.4087 6.55012 16.1625C7.28245 14.9616 8.76729 13.6667 12.0001 13.6667C15.2334 13.6667 16.7182 14.9621 17.4503 16.1632C18.2098 17.4091 18.2222 18.6678 18.2222 18.6678V20.3333H5.77785L5.77778 18.6682Z",
    fill: "#5A6B9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a40954aa46b85631d8968929929ab22d.svg";
export { ForwardRef as ReactComponent };